import React, { useState, useEffect } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import ReactPaginate from 'react-paginate'
import { nextPaginationArrow, prevPaginationArrow } from '../SvgPaths/SvgPaths'
import { getAllBlogs } from '../../services/BlogService'

const AllBlogs = () => {
  const [data, setData] = useState([])
  const [totalPages, setTotalPages] = useState(0)
  const [pageNumber, setPageNumber] = useState(1)
  const blogsPerPage = 12

  const getBlogs = async () => {
    const response = await getAllBlogs(pageNumber, blogsPerPage)
    setData(response.data)
    setTotalPages(response.totalPages)
  }

  useEffect(() => {
    getBlogs()
  }, [pageNumber])

  const handlePageChange = ({ selected }) => {
    setPageNumber(selected + 1)
  }

  const formatDate = timestamp => {
    const date = new Date(timestamp)
    const options = {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    }
    return date.toLocaleDateString('en-US', options)
  }

  return (
    <div className='bg_clr_light_green pb-5 pt-1'>
      <Container>
        <div className='px-lg-5'>
          <Row className='px-md-5'>
            {data.map((value, index) => (
              <Col key={index} lg={4} sm={6}>
                <Link to={`/blog-details/${value._id}`}>
                  <div className='h-100 pt-4'>
                    <div className='blog-cards rounded-2 h-100 d-flex flex-column justify-content-between'>
                      <div>
                        <div>
                          <img
                            style={{ borderRadius: '8px 8px 0 0 ' }}
                            className='w-100 blog-img object-fit-cover'
                            src={value.image}
                            alt={value.title}
                          />
                        </div>
                        <div className='pt-3 px-3'>
                          <h3 className='mb-0 ff_heebo clr_dark_blue fs_xl mt-2 fw-bold'>
                            {value.title}
                          </h3>
                        </div>
                      </div>
                      <div className='pb-3 px-3'>
                        <p className='mb-0 ff_heebo clr_dark_green fs_4xsm mt-2'>
                          {formatDate(value.createdAt)}
                        </p>
                      </div>
                    </div>
                  </div>
                </Link>
              </Col>
            ))}
          </Row>
        </div>
      </Container>

      <div className='pagination-container mt-4'>
        <ReactPaginate
          previousLabel={prevPaginationArrow}
          nextLabel={nextPaginationArrow}
          pageCount={totalPages}
          onPageChange={handlePageChange}
          containerClassName={'pagination justify-content-center mb-0'}
          previousLinkClassName={'pagination__link'}
          nextLinkClassName={'pagination__link'}
          pageClassName={
            'pagination__page d-flex align-items-center justify-content-center clr_dark_grey_3 mx-1 ff_heebo fw-medium fs_xsm'
          }
          disabledClassName={'pagination__link--disabled'}
          activeClassName={
            'pagination__link--active d-flex align-items-center justify-content-center text-white ff_heebo fw-medium fs_xsm'
          }
        />
      </div>
    </div>
  )
}

export default AllBlogs
